import React, { FC, useMemo } from 'react';

import { FormattedList } from 'react-intl';

import { CountryCode } from '~/core/enums';
import { AlternateBroadcast } from '~/core/types';
import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { AlternateBroadcast as AlternateBroadcastSpan } from './styles';

type Props = {
    broadcasts: Array<AlternateBroadcast>;
    location: CountryCode;
};

const AlternateBroadcasts: FC<Props> = ({ broadcasts, location }) => {
    const broadcastsForLocation = useMemo<AlternateBroadcast | undefined>(
        () => broadcasts.find((broadcast) => broadcast.country === location),
        [broadcasts, location]
    );

    if (broadcastsForLocation !== undefined) {
        return (
            <FormattedList
                value={broadcastsForLocation.descriptions.map((description, idx) => (
                    <AlternateBroadcastSpan
                        key={idx}
                        dangerouslySetInnerHTML={{ __html: parseValueFromLocalizedAttribute(description) }}
                    />
                ))}
                type="unit"
            />
        );
    }

    return null;
};

export default AlternateBroadcasts;
